import React from 'react';
import logo from '../../assets/logo.png';

const Logo = () => (
  <img height={80} src={logo} alt="Logo Hapvida | Notredame Intermédica | Hospital Humaniza" />
);

export default Logo;
